import { createSlice } from '@reduxjs/toolkit';
import { dispatch } from '../../store';
import { deleteMethod, get, post, put } from '../../../inteceptor';
import moment from 'moment';

const initialState = {
  error: null,
  time: null,
  data: [],
  allData: [],
  locationBasedPickmeAccountsPerMonth: [],
  addData: {},
  sorted: [],
  PickmeAccountTypes: [],
};

const slice = createSlice({
  name: 'PickMe',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = { message: action.payload, time: moment.now().toString() };
    },

    // GET PickmeAccountManagement
    getAllPickmeAccountTypesSuccess(state, action) {
      state.PickmeAccountTypes = action.payload.data;
    },
    // GET PickmeAccountManagement
    getPickmeAccountsSuccess(state, action) {
      state.data = action.payload.data;
    },
    // GET PickmeAccountManagement
    getAllPickmeAccountsSuccess(state, action) {
      state.allData = action.payload.data;
    },
    // GET PickmeAccountManagement
    locationBasedPickmeAccountsPerMonthSuccess(state, action) {
      state.locationBasedPickmeAccountsPerMonth = action.payload.data;
    },

    addOrUpdatePickmeAccounts(state, action) {
      state.addData = {
        data: action.payload.data,
        time: moment.now().toString(),
      };
    },

    clearAll(state) {
      state.addData = {};
      state.error = {};
    },

    onBackStep(state) {
      state.checkout.activeStep -= 1;
    },

    onNextStep(state) {
      state.checkout.activeStep += 1;
    },

    onGotoStep(state, action) {
      const goToStep = action.payload;
      state.checkout.activeStep = goToStep;
    },
  },
});

// Reducer
export default slice.reducer;

// Actions
export const { filterCategories } = slice.actions;

// ----------------------------------------------------------------------

export function getAllPickmeAccount() {
  return async () => {
    try {
      const response = await get(`PickmeAccountAll`);
      if (response.status) {
        dispatch(slice.actions.getAllPickmeAccountsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function getPickmeAccount() {
  return async () => {
    try {
      const response = await get(`PickmeAccount`);
      if (response.status) {
        dispatch(slice.actions.getPickmeAccountsSuccess(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function addPickmeAccount(body) {
  return async () => {
    try {
      const response = await post(`PickmeAccount`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePickmeAccounts(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function updatePickmeAccount(body) {
  return async () => {
    try {
      const response = await put(`PickmeAccount`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePickmeAccounts(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

// ----------------------------------------------------------------------

export function deletePickmeAccount(body) {
  return async () => {
    try {
      const response = await deleteMethod(`PickmeAccount`, body);
      if (response.status) {
        dispatch(slice.actions.addOrUpdatePickmeAccounts(response));
      } else {
        dispatch(slice.actions.hasError(response.message));
      }
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
